import { render, staticRenderFns } from "./SectionTextLeft.vue?vue&type=template&id=36f8f3c4&scoped=true"
import script from "./SectionTextLeft.vue?vue&type=script&lang=js"
export * from "./SectionTextLeft.vue?vue&type=script&lang=js"
import style0 from "./SectionTextLeft.vue?vue&type=style&index=0&id=36f8f3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8f3c4",
  null
  
)

export default component.exports